import React from 'react';
import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from './components/base_components';

import GameButton from './components/buttons/game_button';
import GameOverlay from './components/overlays/game_overlay';
import PrizeButton from './components/buttons/prize_button';
import PrizeOverlay from './components/overlays/prize_overlay';
import WideButton from './components/buttons/wide_button';
import MenuButton from './components/buttons/menu_button';
import DankCoinDisplay from './components/dank_coin_display';
import EventBanner from './components/events/event_banner';

import { GAME_LIST, Game } from './data/games';
import { PRIZE_LIST, Prize } from './data/prizes';

const styles = StyleSheet.create({
  homeScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
  },
  scrollInner: {
    paddingBottom: 50,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflowY: 'scroll',
  },
  menuButton: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    width: '3em',
    height: '3em',
  },
  topSpacer: {
    height: '4em',
  },
  eventBanner: {
    marginTop: '2em',
  },
  titleWrapper: {
    marginTop: '2em',
    marginLeft: '2em',
    marginRight: '2em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    marginRight: '2em',
    width: '3em',
    height: '3em',
  },
  titleText: {
    marginTop: '0.6em',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  dankCoin: {
    position: 'absolute',
    top: '1em',
    right: '1em',
  },
  subtitleText: {
    marginTop: '2em',
    marginLeft: '2em',
    marginRight: '2em',
    color: 'white',
    fontSize: '1.3em',
    textAlign: 'center',
  },
  sectionText: {
    marginTop: '2em',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  prizeList: {
    marginTop: '2em',
    marginBottom: '5em',
    width: '25em',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  prizeButton: {
    marginTop: '1em',
    marginButtom: '1em',
  },
  gameList: {
    marginTop: '2em',
    marginBottom: '5em',
    width: '25em',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  gameButton: {
    marginTop: '1em',
    marginButtom: '1em',
  },
});

type Props = {
  onNavigate: (string) => void;
};
type State = {
  show_game: Game | null;
  show_prize: Prize | null;
};

const COIN_IMG = require('./assets/img/dank_coin.gif');

export default class HomeScreen extends React.PureComponent<Props, State> {
  state = {
    show_game: null,
    show_prize: null,
  };
  _onGamePress = show_game => this.setState({ show_game });
  _onGameDone = () => this.setState({ show_game: null });

  _onPrizePress = show_prize => this.setState({ show_prize });
  _onPrizeDone = () => this.setState({ show_prize: null });

  _onMoreGamesPress = () => this.props.history.push('/games');
  _onMorePrizesPress = () => this.props.history.push('/prizes');

  render() {
    const { show_game, show_prize } = this.state;
    let overlay = null;
    if (show_game) {
      overlay = <GameOverlay game={show_game} onDone={this._onGameDone} />;
    } else if (show_prize) {
      overlay = <PrizeOverlay prize={show_prize} onDone={this._onPrizeDone} />;
    }

    return (
      <View style={styles.homeScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <DankCoinDisplay style={styles.dankCoin} />
          <View style={styles.topSpacer} />
          <EventBanner style={styles.eventBanner} />
          <View style={styles.titleWrapper}>
            <Image style={styles.icon} resizeMode='contain' source={COIN_IMG} />
            <Text style={styles.titleText}>Dank Coin</Text>
          </View>
          <Text style={styles.subtitleText}>
            Play games, Win coins, Get Stuff
          </Text>
          <Text style={styles.sectionText}>Prizes</Text>
          <View style={styles.prizeList}>
            <PrizeButton
              styles={styles.prizeButton}
              prize={PRIZE_LIST[0]}
              onPress={this._onPrizePress}
            />
            <PrizeButton
              styles={styles.prizeButton}
              prize={PRIZE_LIST[1]}
              onPress={this._onPrizePress}
            />
          </View>
          <WideButton text='More Prizes' onPress={this._onMorePrizesPress} />
          <Text style={styles.sectionText}>Games</Text>
          <View style={styles.gameList}>
            <GameButton
              styles={styles.gameButton}
              game={GAME_LIST[0]}
              onPress={this._onGamePress}
            />
            <GameButton
              styles={styles.gameButton}
              game={GAME_LIST[1]}
              onPress={this._onGamePress}
            />
          </View>
          <WideButton text='More Games' onPress={this._onMoreGamesPress} />
        </ScrollView>
        <MenuButton />
        {overlay}
      </View>
    );
  }
}
